<template>
  <div class="spec-wrap flex flex-col w-full">
    <span class="text-left">Specification</span>

    <div class="w-full" ref="container">
      <div class="flex flex-row mt-3 gap-4">
        <div ref="device" class="flex flex-col items-center pt-4 pb-4  radius-border" style="flex:0.8;height:180px">
          <div class="pl-3 pr-3" >
            <van-image :src="productImage" fit="contain" height="125">
              <template v-slot:loading>
                <van-loading type="spinner" size="50" />
              </template>
            </van-image>
          </div>
          <div class="flex flex-row items-center "  @click="onChangeDevice">
            <img src="@/assets/icons/v2/icon_change_device.svg" />
            <span class="text-17px main-color ml-2">Change</span>
          </div>
        </div>

        <div class="flex-1">
          <FlavorPieChart v-if="pieChartWidth !== 0" :legend="legend" :series="series" height="180px"
            :width="pieChartWidth" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FlavorPieChart from "@/components/FlavorPieChart.vue";
import log from "@/util/log"

export default {
  name: "FlavorDeviceSpecification",
  components: { FlavorPieChart },
  props: {
    seriesData: {
      type: Array,
      default: () => {
        return [];
      }
    },
    productImage: {
      type:String,
      default: ""
    }
  },
  data() {
    return {
      legend: {
        orient: "horizontal",
        top: "bottom",
        bottom: "0", // 图例顶部垂直居中
        icon: "circle"
      },
      series: {
        radius: ["45%", "60%"],
        data: this.seriesData
      },
      pieChartWidth: 0,
      pieChartHeight: 0
    };
  },
  methods: {
    onChangeDevice() {
      this.$emit('onChangeDevice')
    }
  },
  watch: {
    seriesData(newVal) {
      this.series.data = newVal
    }
  },
  mounted() {
    this.$nextTick(() => {
      const pieChartWidth = `${this.$refs.container.clientWidth -
        this.$refs.device.clientWidth}px`;
      log(this.$refs.container.clientHeight);
      this.pieChartWidth = pieChartWidth;
      this.pieChartHeight = `${this.$refs.container.clientHeight}px`;
    });
  }
};
</script>

<style scoped lang="less">
.spec-wrap {
  background: white;
  border-radius: 12px;
}
</style>
